module.exports = __webpack_public_path__ + "img/5.98536257.png";